import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

export async function hideLaunchScreen() {
  const splash = document.getElementById('app-splash');
  // A root remount can report readiness after the launch handoff has completed.
  if (!splash) {
    return;
  }
  let duration = 500;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    duration = 0;
  }
  if (Capacitor.isNativePlatform()) {
    splash.remove();
    await SplashScreen.hide({ fadeOutDuration: duration });
  } else {
    await splash.animate([{ opacity: 1 }, { opacity: 0 }], { duration, easing: 'ease-in-out' })
      .finished;
    splash.remove();
  }
  document.getElementById('app').inert = false;
}

export async function showLaunchError(t) {
  const splash = document.getElementById('app-splash');
  splash.setAttribute('role', 'alert');
  splash.removeAttribute('aria-label');
  const error = document.getElementById('app-launch-error');
  error.hidden = false;
  error.querySelector('p').textContent = t('common.startupFailed');
  const retry = error.querySelector('button');
  retry.textContent = t('common.retry');
  retry.addEventListener('click', () => window.location.reload(), { once: true });
  if (Capacitor.isNativePlatform()) {
    await SplashScreen.hide({ fadeOutDuration: 0 });
  }
}
